<template>
    <el-card shadow="never">
      <template #header>
        <div class="header">
          <el-breadcrumb class="breadcrumb" separator="/">
            <el-breadcrumb-item>店铺设置</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </template>
      <div style="width:80%">
        <el-form :model="form" label-width="180px">
          <div>
            <el-divider content-position="left">店铺</el-divider>
            <el-form-item label="" >
              <el-radio-group v-model="form.seller_id">
                <el-radio v-for="item1 in baseData.sellerList" :key="item1.store_id" :label="item1.store_id" :value="item1.store_id">{{ item1.store_name }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <el-form-item>
            <el-button type="success" @click="save">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </template>
  <script lang="ts" setup>
  import { reactive, onMounted } from 'vue'
  import api from '@/api/index'
  import { ElMessage, ElLoading } from 'element-plus'
  const form = reactive({
    platform_code:10016,
    seller_id:"",
  })
  const baseData:any = reactive({
    sellerList:[],
  })
  
  const getSellerList = () => {
    const loading = ElLoading.service({lock: true})
    api.lingxingApi.getSellerList({platform_code:form.platform_code}).then((res:any)=>{
      if(res.code==200){
        baseData.sellerList = res.data.list
        form.seller_id = res.data.seller_id
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  const save =  () => { 
    const loading = ElLoading.service({lock: true})
    api.lingxingApi.save_store({seller_id: form.seller_id}).then((res:any)=>{
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        getSellerList()
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  
  onMounted(() => {
    getSellerList()
  })
  </script>